export default __webpack_public_path__ + "static/slider6-d12f2c1953a7c5f6b96d67e448f46d74.jpg";